import { Observable } from 'rxjs';

import { UnitResult } from '../../../../error';
import { Job } from '../../Model/CreateJob/create-job.model';
import { JobId } from '../../Model/Job/VO/job-id';

export abstract class CreateJobService {
    abstract createJob(model: Job): Observable<UnitResult<JobId>>;
}
